export default __webpack_public_path__ + "static/media/wave-02.3025b9a8.png";